"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGuidelines = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const use_guidelines_query_1 = require("../gql/use-guidelines.query");
const client_constants_1 = require("../../../../client/client.constants");
const hooks_1 = require("../../../../client/hooks");
// merge the new part with an already loaded
const updateQuery = (previousResult, options) => {
    var _a, _b, _c, _d, _e, _f;
    const { productTreeNode } = (_a = options === null || options === void 0 ? void 0 : options.fetchMoreResult) !== null && _a !== void 0 ? _a : {};
    const previousNode = (_b = previousResult.productTreeNode.labelValidation.edges[0]) === null || _b === void 0 ? void 0 : _b.node;
    const nextNode = (_d = (_c = productTreeNode === null || productTreeNode === void 0 ? void 0 : productTreeNode.labelValidation) === null || _c === void 0 ? void 0 : _c.edges[0]) === null || _d === void 0 ? void 0 : _d.node;
    const previousValueEdges = (_e = previousNode === null || previousNode === void 0 ? void 0 : previousNode.values.edges) !== null && _e !== void 0 ? _e : [];
    const nextValueEdges = (_f = nextNode === null || nextNode === void 0 ? void 0 : nextNode.values.edges) !== null && _f !== void 0 ? _f : [];
    return {
        productTreeNode: Object.assign(Object.assign(Object.assign({}, previousResult.productTreeNode), productTreeNode), { labelValidation: Object.assign(Object.assign(Object.assign({}, previousResult.productTreeNode.labelValidation), productTreeNode.labelValidation), { edges: [{
                        node: Object.assign(Object.assign(Object.assign({}, previousNode), nextNode), { values: Object.assign(Object.assign(Object.assign({}, previousNode === null || previousNode === void 0 ? void 0 : previousNode.values), nextNode === null || nextNode === void 0 ? void 0 : nextNode.values), { edges: [
                                    ...previousValueEdges,
                                    ...nextValueEdges,
                                ] }) }),
                    }] }) }),
    };
};
const fetchMoreOptions = { updateQuery };
const useGuidelines = ({ productTreeNodeId, label }) => {
    var _a, _b, _c, _d, _e, _f;
    const variables = (0, react_1.useMemo)(() => ({
        productTreeNodeId,
        label,
        first: client_constants_1.PAGE_SIZE_LARGE,
    }), [label, productTreeNodeId]);
    const { data, fetchMore, networkStatus, } = (0, react_2.useQuery)(use_guidelines_query_1.GET_NODE_GUIDELINES, {
        variables,
        skip: !productTreeNodeId || !label,
        // cache-and-network: serve cached values immediately (no loading flash on re-open)
        // then silently refetch so the sidebar stays in sync when strategy values are updated.
        fetchPolicy: 'cache-and-network',
    });
    const { edges } = (_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.labelValidation) !== null && _b !== void 0 ? _b : { edges: [] };
    const { title: nodeTitle, description: nodeDescription } = (data === null || data === void 0 ? void 0 : data.productTreeNode) || {};
    const values = (_d = (_c = edges[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.values;
    const attributeValues = (_e = values === null || values === void 0 ? void 0 : values.edges) !== null && _e !== void 0 ? _e : [];
    const { label: attributeTitle, description: attributeDescription, } = ((_f = edges[0]) === null || _f === void 0 ? void 0 : _f.node) || {};
    const pageInfo = values === null || values === void 0 ? void 0 : values.pageInfo;
    const pagination = (0, hooks_1.usePagination)({
        networkStatus,
        pageInfo,
        pageSize: client_constants_1.PAGE_SIZE_LARGE,
        fetchMore,
        fetchMoreOptions,
        lastVariables: variables,
    });
    return {
        pagination,
        nodeTitle,
        nodeDescription,
        attributeTitle,
        attributeDescription,
        attributeValues: attributeValues.map(({ node }) => node),
    };
};
exports.useGuidelines = useGuidelines;
